import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Grid,
  Typography,
  Avatar,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  ListItemIcon,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { Image, DatePicker } from "antd";
import MDButton from "components/MDButton";
import { getSecureUrl } from "utils/secureDownload";
import { extractKeyFromUrl } from "utils/pathHelpers";
import axios from "axios";
import { Avatar as Avatar1 } from "antd";
import { Rate } from "antd";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import {
  Card as AntCard,
  Form,
  Input,
  Radio,
  InputNumber,
  Select,
  Modal,
} from "antd";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { green } from "@mui/material/colors";
import { Button } from "antd";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { UserOutlined } from "@ant-design/icons";
import WifiIcon from "@mui/icons-material/Wifi";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import WcIcon from "@mui/icons-material/Wc";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import HotelIcon from "@mui/icons-material/Hotel";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import MedicationIcon from "@mui/icons-material/Medication";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import StoreIcon from "@mui/icons-material/Store";
import NatureIcon from "@mui/icons-material/Nature";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import EngineeringIcon from "@mui/icons-material/Engineering";
import TempleHinduIcon from "@mui/icons-material/TempleHindu";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import CustomMaterialTable from "../../components/custom/CustomMaterialTable";
import Loader from "components/custom/Loader";
import { Divider } from "antd";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Tooltip from "@mui/material/Tooltip";
import { useLocation } from "react-router-dom";
import "./Viewlocation.css";
import { convertUTCtoDubai } from "utils/Constant";
import dummyImg from "../../assets/images/dummy_Image.png"

import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import EditIcon from "@mui/icons-material/Edit";
import "./Somecss.css";
import { Generateqr } from "utils/Generateqr";
import { AutoTooltip } from "utils/Constant";


import { handleSignout } from "utils/Logout";
import { getDecodedUserData } from "utils/Constant";

const { Option } = Select;
const DUMMY_IMG = dummyImg;
const iconMap = {
  "Petrol Pumps": <LocalGasStationIcon />,
  "Shopping Centers": <ShoppingCartIcon />,
  Hotels: <HotelIcon />,
  Cafes: <LocalCafeIcon />,
  ATM: <LocalAtmIcon />,
  Pharmacies: <MedicationIcon />,
  "Wi-Fi Zones": <WifiIcon />,
  "Grocery Stores": <StoreIcon />,
  "EV Maintenance Services": <EngineeringIcon />,
  "Car Wash": <LocalCarWashIcon />,
  "Recreational Areas": <NatureIcon />,
  "Fitness Centers": <FitnessCenterIcon />,
  "Cultural Sites": <TempleHinduIcon />,
  "Public Transportation Hubs": <EmojiTransportationIcon />,
  Toilets: <WcIcon />,
  Parking: <LocalParkingIcon />,
  Restaurants: <RestaurantIcon />,
};

const colorMap = {
  primary: "#f00000",
  info: "#1A73E8",
  success: "#4CAF50",
  warning: "#FF9800",
  error: "#F44336",
  dark: "#212121",
};
const normalizeBlobKey = (key) => {
  if (!key) return key;
  const parts = key.split("/");
  if (parts.length === 0) return key;

  parts[0] = parts[0].toLowerCase();

  return parts.join("/");
};

const ViewLocation = () => {
  const [form] = Form.useForm();
  const { enqueueSnackbar } = useSnackbar();
  const [, setFormValues] = useState({
    chargerInfo: [{}],
  });
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const [isLocationTableLoading, setIsLocationTableLoading] = useState(true);
  const [, setIsLoading] = useState(true);
  const [isReviewTableLoading, setIsReviewTableLoading] = useState(true);
  const { darkMode } = controller;
  const { sidenavColor } = controller;
  const [columns, setColumns] = useState([]);
  const [columns1, setColumns1] = useState([]);
  const [rows, setRows] = useState([]);
  const [rows1, setRows1] = useState([]);
  const [additionalImages, setAdditionalImages] = useState([]);
  const location = useLocation();
  const [content, setContent] = useState([]);
  const [editChargerInfo, setEditChargerInfo] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog1, setOpenDialog1] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("AED");
  const [connectors1, setConnectors1] = useState([]);
  const [connectors2, setConnectors2] = useState([]);
  const [isLoading2, setIsLoading2] = useState(true);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrModalLoading, setQrModalLoading] = useState(false);
  const [qrModalUrl, setQrModalUrl] = useState(null);
  const [qrModalTitle, setQrModalTitle] = useState("");
  const [qrModalKey, setQrModalKey] = useState(null);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedCurrency("AED");
  };
  const handleChangeCurrency = (e) => {
    setSelectedCurrency(e);
  };
  const handleCloseDialog1 = () => {
    setOpenDialog1(false);
    setSelectedCurrency("AED");
    setEditChargerInfo([]);
    window.location.reload();
  };
  const navEdit = () => {
    navigate("/location/edit", { state: content });
  };

  const isVideoUrl = (url) => {
    if (!url || typeof url !== "string") return false;
    const lower = url.toLowerCase();
    return lower.includes(".mp4");
  };

  const [mainDisplayUrl, setMainDisplayUrl] = useState(DUMMY_IMG);

  useEffect(() => {
    const load = async () => {
      const rawKey = content?.locationImage?.[0];
      if (!rawKey) return setMainDisplayUrl(DUMMY_IMG);

      const key = normalizeBlobKey(rawKey);

      try {
        const secure = await getSecureUrl(key);
        setMainDisplayUrl(secure || DUMMY_IMG);
      } catch {
        setMainDisplayUrl(DUMMY_IMG);
      }
    };

    load();
  }, [content?.locationImage]);

  <Image
    src={mainDisplayUrl}
    alt="Location Image"
    style={{
      width: "100%",
      height: 300,
      objectFit: "cover",
      borderRadius: 12,
    }}
  />;

  const statusList = [
    "Available",
    "Charging",
    "Preparing",
    "Finishing",
    "SuspendedEVSE",
    "Faulted",
    "Inactive",
    "Reserved",
  ];
  const selectAfter = (
    <Select
      defaultValue="AED"
      style={{ width: 100 }}
      onChange={(e) => handleChangeCurrency(e)}
    >
      <Option value="AED">د.إ (AED)</Option>
      <Option value="INR">&#8377; (INR)</Option>
      <Option value="USD">$ (USD)</Option>
      <Option value="EUR">€ (EUR)</Option>
      <Option value="GBP">£ (GBP)</Option>
      <Option value="CNY">¥ (CNY)</Option>
    </Select>
  );
  const handleTypeChange = (key, e) => {
    const value = e.target.value;
    const chargerInfo = form.getFieldValue("chargerInfo") || [];
    const updatedChargerInfo = chargerInfo.map((info, index) => {
      if (index === key) {
        return {
          ...info,
          type: value,
          subtype: value === "AC" ? "CCS2" : "Type6",
        };
      }
      return info;
    });

    form.setFieldsValue({ chargerInfo: updatedChargerInfo });
  };
  const handleTypeChange1 = (key, e) => {
    const value = e.target.value;
    const chargerInfo1 = form.getFieldValue("chargerInfo1") || [];
    const updatedChargerInfo = chargerInfo1.map((info, index) => {
      if (index === key) {
        return {
          ...info,
          type: value,
          subtype: value === "AC" ? "CCS2" : "Type6",
        };
      }
      return info;
    });

    form.setFieldsValue({ chargerInfo1: updatedChargerInfo });
  };

  const handleViewQr = async (row) => {
    const qrKeyOrUrl = row?.qrcodeurl;
    if (!qrKeyOrUrl) return;

    try {
      setQrModalTitle(`${row.name} - ${row.connectorId}`);
      setQrModalOpen(true);
      setQrModalLoading(true);
      setQrModalUrl(null);

      const key = extractKeyFromUrl(qrKeyOrUrl);
      setQrModalKey(key);

      const secureUrl = await getSecureUrl(key, 60);
      setQrModalUrl(secureUrl);
    } catch (e) {
      console.error("Failed to load secure QR:", e);
      enqueueSnackbar("Failed to load QR code", { variant: "error" });
    } finally {
      setQrModalLoading(false);
    }
  };

  const handleDownloadQr = async () => {
    if (!qrModalKey) return;

    try {

      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}download?key=${encodeURIComponent(
          qrModalKey
        )}`,
        {
          method: "GET",
          withCredentials: true,

        }
      );

      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        qrModalKey.split("/").pop() || "qrcode.png"
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Failed to download QR:", err);
      enqueueSnackbar("Failed to download QR code", { variant: "error" });
    }
  };

  const handleEdit = (row_data) => {
    handleConnectorChange2(row_data?.NoOfconnector);
    const updatedChargerData = {
      ...row_data,
      powerOutput: row_data.powerOutput.replace(/\s*kW$/i, "").trim(),
      energyConsumptions: row_data.energyConsumptions
        .replace(/\s*kWh$/i, "")
        .trim(),
      amount: row_data.costPerUnit.amount,
    };
    setEditChargerInfo([updatedChargerData]);
    setOpenDialog1(true);
  };

  const handleUpdateCharger = () => {
    form
      .validateFields()
      .then(() => {
        const chargerData = form.getFieldValue("chargerInfo1")[0];
        const updatedChargerData = {
          ...chargerData,
          powerOutput: `${chargerData.powerOutput} kW`,
          energyConsumptions: `0 kWh`,
          costPerUnit: {
            amount: chargerData.amount,
            currency: selectedCurrency,
          },
          connectors: connectors2,
        };
        const payload = {
          location_id: location?.state,
          charger_id: chargerData?._id,
          updatedChargerInfo: updatedChargerData,
        };

        axios({
          method: "post",
          url:
            process.env.REACT_APP_BASEURL + "charger-locations/update-charger",
          data: payload,
          headers: {
            "Content-Type": "application/json",
          }, withCredentials: true,

        })
          .then((response) => {
            if (response.data.success === true) {
              enqueueSnackbar("Charger Updated Successfully.", {
                variant: "success",
              });
              form.resetFields(["chargerInfo"]);
              navigate("/location");
            } else {
              enqueueSnackbar(response.data.message, { variant: "error" });
            }
          })
          .catch((error) => {
            enqueueSnackbar("Error Occurred while Adding Charger.", {
              variant: "error",
            });
            if (error?.response?.status === 401) {
              handleSignout();
            }
          });

        setOpenDialog(false);
      })
      .catch((error) => {
        enqueueSnackbar("Please fill in all required fields.", {
          variant: "warning",
        });
      });
  };
  const handleAddCharger = () => {
    form
      .validateFields()
      .then(() => {
        const chargerData = form.getFieldValue("chargerInfo")[0]; // Get the single charger entry from the form
        const updatedChargerData = {
          ...chargerData,

          onboardingDate: chargerData.onboardingDate
            ? chargerData.onboardingDate.format("YYYY-MM-DD")
            : null,

          powerOutput: `${chargerData.powerOutput} kW`,
          energyConsumptions: `0 kWh`,
          costPerUnit: {
            amount: chargerData.amount,
            currency: selectedCurrency,
          },
          connectors: connectors1,
        };

        const payload = {
          location_id: content._id,
          newChargerInfo: updatedChargerData,
        };

        axios({
          method: "post",
          url: process.env.REACT_APP_BASEURL + "charger-locations/add-charger",
          data: payload,
          headers: {
            "Content-Type": "application/json",
          }, withCredentials: true,

        })
          .then((response) => {
            if (response.data.success === true) {
              const payload = {
                payload: {
                  connectorId: 1,
                  chargerId: updatedChargerData?.name,
                },
              };
              Generateqr("encrypt-param", "POST", payload);
              enqueueSnackbar("Charger Added Successfully.", {
                variant: "success",
              });
              form.resetFields(["chargerInfo"]); // Reset the form after successful addition
              navigate("/location");
            } else {
              enqueueSnackbar(response.data.message, { variant: "error" });
            }
          })
          .catch((error) => {
            enqueueSnackbar("Error Occurred while Adding Charger.", {
              variant: "error",
            });
            if (error?.response?.status === 401) {
              handleSignout();
            }
          });

        setOpenDialog(false); // Close the dialog
      })
      .catch((error) => {
        enqueueSnackbar("Please fill in all required fields.", {
          variant: "warning",
        });
      });
  };
  const handleGenerate = async (row_data) => {
    const payload = {
      payload: {
        connectorId: row_data?.connectorId,
        chargerId: row_data?.charger_id,
      },
    };
    const data = await Generateqr("encrypt-param", "POST", payload);
    if (data?.status === true) {
      enqueueSnackbar(data?.message || "QR Code is Generated Successfully!", {
        variant: "success",
      });
      window.location.reload();
    } else {
      enqueueSnackbar(data?.message || "QR Code Generation Failed!", {
        variant: "error",
      });
    }
  };

  const fetchLocation = async () => {
    await axios
      .get(
        process.env.REACT_APP_BASEURL + `charger-locations/${location.state}`,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        if (response.data.success) {
          const location = response.data.data;
          setContent(location);
          setIsLoading2(false);
          setIsLocationTableLoading(false);
          if (location) {
            const transformedData = location.chargerInfo.flatMap((charger) =>
              charger?.connectors.map((connector) => ({
                locationName: location.locationName,
                name: charger.name,
                _id: charger._id,
                charger_id: charger.name,
                powerOutput: charger.powerOutput,
                type: `${charger.type}`,
                energyConsumptions: charger.energyConsumptions,
                qrcodeurl: connector?.qrCodeUrl || null,
                NoOfconnector: charger?.NoOfconnector || 0,
                status: connector?.status || "Inactive",
                subtype: charger?.subtype,
                costPerUnit: charger?.costPerUnit,
                chargePointSerialNumber:
                  charger?.otherDatas?.chargePointSerialNumber,
                chargePointVendor: charger?.otherDatas?.chargePointVendor,
                chargePointModel: charger?.otherDatas?.chargePointModel,
                model: charger?.otherDatas?.model,
                firmwareVersion: charger?.otherDatas?.firmwareVersion,
                iccid: charger?.otherDatas?.iccid || "N/A",
                imsi: charger?.otherDatas?.imsi || "N/A",
                chargerId: connector?.charger_id || 0,
                connectorId: connector?.connectorId || 0,
                last_ping: connector?.lastPing ? connector?.lastPing : "N/A",
                chargerName: charger?.chargerName,
              }))
            );
            setRows(transformedData);
            setIsLoading(false);
            if (location?.locationImage && location.locationImage.length > 1) {
              let extraImages = location.locationImage.slice(1);

              if (extraImages.length > 5) {
                extraImages = extraImages.slice(-5);
              }

              setAdditionalImages(extraImages);
            } else {
              setAdditionalImages([]);
            }
          }
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
          setIsLoading2(false);
          setIsLocationTableLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading2(false);
        setIsLocationTableLoading(false);
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
  };
  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
    if (!location.state) {
      navigate("/location");
    }
    fetchLocation();
    axios({
      method: "get",
      url: process.env.REACT_APP_BASEURL + "reviews/location/" + location.state,
      withCredentials: true,

    })
      .then((response) => {
        if (response.data.success === true) {
          setRows1(response.data.data);
          setIsReviewTableLoading(false);
        } else {
          enqueueSnackbar(response.data.message, { variant: "info" });
          setIsReviewTableLoading(false);
        }
      })
      .catch((error) => {
        setIsReviewTableLoading(false);
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatEnergy = (raw) => {
    if (!raw) return "0 kWh";
    const num = parseFloat(String(raw).replace(/[^\d.-]/g, "")) || 0;
    if (num >= 1000) {
      return `${(num / 1000).toFixed(2)} MWh`;
    }

    return `${num.toFixed(2)} kWh`;
  };

  const handleConnectorChange1 = (value) => {
    const count = value || 0;

    const generatedConnectors = Array.from({ length: count }, (_, index) => ({
      connectorId: index + 1,
    }));

    setConnectors1(generatedConnectors);
  };
  const handleConnectorChange2 = (value) => {
    const count = value || 0;

    const generatedConnectors = Array.from({ length: count }, (_, index) => ({
      connectorId: index + 1,
    }));

    setConnectors2(generatedConnectors);
  };

  const handleViewCharger = async (row_data) => {
    try {
      navigate("/charger/view", {
        state: {
          charger_id: row_data?.name,
          connectorId: row_data?.connectorId,
        },
      });
    } catch (error) {
      enqueueSnackbar("Failed to open charger page", { variant: "error" });
    }
  };

  const column = useMemo(
    () => [
      {
        header: "Charger Name",
        accessorKey: "chargerName",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        size: 250
      },
      {
        header: "Status",
        accessorKey: "status",
        filterVariant: "select",
        filterSelectOptions: statusList,

        filterFn: (row, id, filterValue) => {
          if (Array.isArray(filterValue)) {
            return filterValue.includes(row.getValue(id));
          }
          return row
            .getValue(id)
            .toLowerCase()
            .includes(filterValue.toLowerCase());
        },

        align: "center",
        fixed: "true",
        size: 190,
        muiTableHeadCellProps: {
          align: "center",
        },

        muiTableBodyCellProps: {
          align: "center",
        },

        Cell: ({ row }) => {
          const status = row.original.status;
          const lastPing = row.original.last_ping;

          const statusColors = {
            Faulted: "red",
            Inactive: "default",
            Available: "green",
            Charging: "blue",
            SuspendedEVSE: "orange",
            Finishing: "purple",
            Reserved: "pink",
            Preparing: "yellow",
          };

          const color = statusColors[status] || "yellow";

          const label = lastPing === "NA" ? "Disconnect" : status;

          return (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              borderRadius="md"
              style={{ flex: 1 }}
            >
              <Tag
                style={{
                  minWidth: "60px",
                  textAlign: "center",
                  display: "inline-block",
                }}
                color={color}
              >
                {label}
              </Tag>
            </MDBox>
          );
        },
      },
      {
        header: "Charger ID",
        accessorKey: "charger_id",
        align: "center",
        size: 220,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ row }) => {
          const chargerId = row?.original?.charger_id;
          const connectorId = row?.original?.connectorId;

          let connectorLabel = null;

          if (connectorId === 1) {
            connectorLabel = "A"; // if backend sends A and B, keep A
          } else if (connectorId === 2) {
            connectorLabel = "B";
          }

          return (
            <span
              onClick={() => handleEdit(row.original)}
              style={{
                color: "#1E88E5",
                cursor: "pointer",
                textDecoration: "underline",
                whiteSpace: "nowrap",
              }}
            >
              {chargerId}
              {connectorLabel ? ` - ${connectorLabel}` : ""}
            </span>
          );
        },
      }
      ,
      {
        header: "Location Name",
        accessorKey: "locationName",
        size: 260,
        Cell: ({ cell }) => (
          <AutoTooltip maxWidth={50}>
            {cell.getValue() || "-"}
          </AutoTooltip>
        ),
      },

      //   {
      //   header: "Total Energy Consumed",
      //   accessorKey: "energy_disp",
      //   align: "center",
      //   muiTableHeadCellProps: {
      //     align: "center",
      //   },
      //   muiTableBodyCellProps: {
      //     align: "center",
      //   },
      //   size:320
      // },

      // {
      //   header: "Onboarding Date",
      //   accessorKey: "onboarding_date",
      //   align: "center",
      //   muiTableHeadCellProps: {
      //     align: "center",
      //   },
      //   muiTableBodyCellProps: {
      //     align: "center",
      //   },
      //   size:270,
      //   Cell: ({ cell }) => {
      //     return convertUTCtoDubai(cell.getValue());
      //   },
      // },

      {
        header: "Last ping",
        accessorKey: "last_ping",
        align: "center",
        size: 210,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
        },
      },
      {
        header: "QR Code",
        accessorKey: "qrcodeurl",
        align: "center",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ row }) => {
          const hasQr = !!row.original.qrcodeurl;

          if (!hasQr) return "N/A";

          return (
            <MDButton
              size="small"
              variant="outlined"
              onClick={() => handleViewQr(row.original)}
              sx={{
                minWidth: "auto",
                color: "#1976d2",
                textTransform: "none",
                "&:hover": { backgroundColor: "#e3f2fd" },
              }}
            >
              View QR
            </MDButton>
          );
        },
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        align: "center", muiTableHeadCellProps: {
          align: 'center',
        },
        pinned: 'right',
        size: 190,
        muiTableBodyCellProps: {
          align: 'center',
        },
        // Cell: (row) => (


        //   <div
        //     key={`action-cell-${row.row.id}-${sidenavColor}`}
        //     style={{

        //       position: 'sticky',
        //       right: '0',
        //       // backgroundColor:'white',
        //       // zIndex: '111',
        //     }}>

        //     {/* {row.row.original.qrcodeurl === null && */}
        //     <MDButton
        //       // key={sidenavColor}
        //       sx={{
        //         marginLeft: 2,
        //       }}
        //       onClick={(e) => handleGenerate(row.row.original)}
        //       variant="gradient"
        //       color={sidenavColor}
        //       // color="info"
        //       iconOnly
        //     >
        //       <img src={`${process.env.REACT_APP_AWS_BASEURL}cms-icons/Regenarte+scan+qr+code.svg`} alt="QR Code" style={{ width: '20px', height: '20px' }} />
        //     </MDButton>
        //     {/* } */}


        //   </div>
        // ),
        Cell: ({ row }) => {

          const [anchorEl, setAnchorEl] = useState(null);
          const open = Boolean(anchorEl);

          const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
          };

          const handleClose = () => {
            setAnchorEl(null);
          };
          const handleAction = (action) => {
            action();
            handleClose();
          };


          return (
            <>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MoreVertIcon />
              </IconButton>

              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  sx: {
                    py: 0.25,
                  },
                }}
                PaperProps={{
                  sx: {
                    minWidth: 210,
                    borderRadius: 1,
                  },
                }}
              >
                {/* Edit User */}
                <MenuItem
                  onClick={() => handleAction(() => handleEdit(row.original))}
                  sx={{
                    py: 1,
                    px: 1.5,
                    gap: 1,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 28,
                      color: "#8A8AAE",
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </ListItemIcon>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#8A8AAE",
                    }}
                  >
                    Edit Charger
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => handleAction(() => handleGenerate(row.original))}
                  sx={{
                    py: 1,
                    px: 1.5,
                    gap: 1,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      "& img": {
                        width: 20,
                        height: 20,
                        filter: "brightness(0) invert(0.6)",
                      },
                    }}
                  >
                    <img src={`${process.env.REACT_APP_AWS_BASEURL}cms-icons/Regenarte+scan+qr+code.svg`} alt="QR Code" style={{ width: '20px', height: '20px' }} />
                  </ListItemIcon>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#8A8AAE",
                    }}
                  >
                    Generate QR Code
                  </Typography>
                </MenuItem>

              </Menu>

            </>
          );
        },
      },


      {
        header: "Address",
        accessorKey: "address",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "City",
        accessorKey: "city",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "State",
        accessorKey: "state",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Model",
        accessorKey: "model",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Power Output",
        accessorKey: "powerOutput",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Type",
        accessorKey: "type",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },

      {
        header: "Firmware Version",
        accessorKey: "firmwareVersion",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "IMSI",
        accessorKey: "imsi",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "ICCID",
        accessorKey: "iccid",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },


    ],
    [sidenavColor]
  );
  useEffect(() => {
    setColumns(column);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidenavColor]);

  const formatTime = (time) => {
    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(hours, minutes);

    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const column1 = [
    {
      header: "Full Name",
      align: "center",
      filterVariant: "text",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      }, // default
      Cell: (row) => (
        <div>
          {row.row.original?.user?.status === "active" ? (
            <Avatar1
              icon={<UserOutlined />}
              style={{
                backgroundColor: "#87d068",
                // color: '#f56a00',
                marginRight: "1rem",
              }}
            />
          ) : (
            <Avatar1
              icon={<UserOutlined />}
              style={{
                marginRight: "1rem",
              }}
            />
          )}

          {`${row.row.original?.user?.firstName} ${row.row.original?.user?.lastName}`}
        </div>
      ),
    },
    {
      header: "Charging Experience",
      accessorKey: "charging_exp",
      align: "center",
      fixed: "true",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: (row) => (
        <div>
          <Rate
            style={{ color: "#ADDD8C" }}
            disabled
            defaultValue={row.row.original.charging_exp}
          />
        </div>
      ),
    },
    {
      header: "Charging Location",
      accessorKey: "charging_location",
      align: "center",
      fixed: "true",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: (row) => (
        <div>
          <Rate
            style={{ color: "#ADDD8C" }}
            disabled
            defaultValue={row.row.original.charging_location}
          />
        </div>
      ),
    },
    {
      header: "Review",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "review",
      align: "center",
    },
  ];
  useEffect(() => {
    setColumns(column);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setColumns1(column1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => { }, []);

  const data = {
    locationName: "MCC - Mysore road",
    address: "Bangalore, Karnataka",
    type: "Mall",
    accessibility: "Public",
    stats: {
      total: rows.length || 0,
      ac: rows.filter((charger) => charger.type === "AC").length || 0,
      dc: rows.filter((charger) => charger.type === "DC").length || 0,
      twoWheelerDC:
        rows.filter((charger) => charger.type === "twoWheelerDC").length || 0,
      energyDispersed: 3000,
      visits: 90,
      occupancyRate: 75,
      kmsPowered: 30000,
      co2Saved: 1245,
      uptimeRate: 90,
    },
    contact: {
      phone: "+91 9090909090",
      spoc: {
        name: "Visswanath",
        phone: "9876543210",
      },
      accounts: {
        name: "Visswanath",
        phone: "9876543210",
      },
      maintenance: {
        name: "Visswanath",
        phone: "9876543210",
      },
      gm: {
        name: "Visswanath",
        phone: "9876543210",
      },
      siteEngineer: {
        name: "Visswanath",
        phone: "9876543210",
      },
    },
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isLoading2 ? (
        <MDBox
          py={3}
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="60vh"
        >
          <Loader />
        </MDBox>
      ) : (
        <MDBox py={3}>
          <Box>
            <Grid container spacing={3}>
              {/* Header Section */}
              <Grid item xs={12}>
                <Card
                  sx={{
                    boxShadow: darkMode
                      ? "0 4px 12px rgba(0,0,0,0.3)"
                      : "0 4px 12px rgba(0,0,0,0.1)",
                    borderRadius: "16px",
                    border: "1px solid",
                    borderColor: darkMode
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.08)",
                    mb: 3,
                  }}
                >
                  <MDBox p={3}>
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={12} md={8}>
                        <MDBox mb={1.5}>
                          {content?.status === "Active" ? (
                            <Tag icon={<CheckCircleOutlined />} color="success">
                              Live
                            </Tag>
                          ) : content?.status === "Pending" ? (
                            <Tag icon={<SyncOutlined spin />} color="warning">
                              Pending
                            </Tag>
                          ) : content?.status === "Inactive" ? (
                            <Tag icon={<CloseCircleOutlined />} color="error">
                              Inactive
                            </Tag>
                          ) : content?.status === "Waitlisted" ? (
                            <Tag icon={<ClockCircleOutlined />} color="default">
                              waiting
                            </Tag>
                          ) : (
                            <Tag icon={<MinusCircleOutlined />} color="default">
                              {content?.status}
                            </Tag>
                          )}
                        </MDBox>
                        <MDTypography variant="h4" fontWeight="bold" mb={1}>
                          {content?.locationName}
                        </MDTypography>
                        <MDTypography
                          variant="body1"
                          sx={{ opacity: 0.8 }}
                          mb={0.5}
                        >
                          {content?.city}, {content?.state}
                        </MDTypography>
                        <MDTypography variant="body2" sx={{ opacity: 0.7 }}>
                          {content?.locationType} | {data.accessibility}
                        </MDTypography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={4}
                        sx={{ textAlign: { xs: "start", md: "end" } }}
                      >
                        <Button
                          type="primary"
                          style={{ backgroundColor: `${colorMap["primary"]}` }}
                          size="large"
                          icon={<EditIcon />}
                          onClick={navEdit}
                        >
                          Edit Location
                        </Button>
                      </Grid>
                    </Grid>
                  </MDBox>
                </Card>
              </Grid>
              {/* Statistics Section - Full Width */}
              <Grid item xs={12}>
                <Card
                  sx={{
                    boxShadow: darkMode
                      ? "0 4px 12px rgba(0,0,0,0.3)"
                      : "0 4px 12px rgba(0,0,0,0.1)",
                    borderRadius: "16px",
                    border: "1px solid",
                    borderColor: darkMode
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.08)",
                  }}
                >
                  <MDBox p={3}>
                    <MDTypography variant="h5" fontWeight="bold" mb={3}>
                      Charger Statistics
                    </MDTypography>
                    <Grid container spacing={3}>
                      <Grid item xs={6} sm={3}>
                        <MDBox
                          sx={{
                            background: darkMode
                              ? "linear-gradient(195deg, rgba(66, 165, 245, 0.1), rgba(25, 118, 210, 0.1))"
                              : "linear-gradient(195deg, rgba(66, 165, 245, 0.05), rgba(25, 118, 210, 0.05))",
                            borderRadius: "12px",
                            padding: "20px",
                            textAlign: "center",
                            border: "1px solid",
                            borderColor: darkMode
                              ? "rgba(66, 165, 245, 0.2)"
                              : "rgba(66, 165, 245, 0.15)",
                          }}
                        >
                          <MDTypography
                            variant="h3"
                            fontWeight="bold"
                            color="info"
                          >
                            {data.stats.total}
                          </MDTypography>
                          <MDTypography
                            variant="button"
                            fontWeight="medium"
                            sx={{ opacity: 0.8, mt: 1 }}
                          >
                            Total Charge Points
                          </MDTypography>
                        </MDBox>
                      </Grid>
                      <Grid item xs={6} sm={3}>
                        <MDBox
                          sx={{
                            background: darkMode
                              ? "linear-gradient(195deg, rgba(76, 175, 80, 0.1), rgba(56, 142, 60, 0.1))"
                              : "linear-gradient(195deg, rgba(76, 175, 80, 0.05), rgba(56, 142, 60, 0.05))",
                            borderRadius: "12px",
                            padding: "20px",
                            textAlign: "center",
                            border: "1px solid",
                            borderColor: darkMode
                              ? "rgba(76, 175, 80, 0.2)"
                              : "rgba(76, 175, 80, 0.15)",
                          }}
                        >
                          <MDTypography
                            variant="h3"
                            fontWeight="bold"
                            color="success"
                          >
                            {data.stats.ac}
                          </MDTypography>
                          <MDTypography
                            variant="button"
                            fontWeight="medium"
                            sx={{ opacity: 0.8, mt: 1 }}
                          >
                            AC Charge Points
                          </MDTypography>
                        </MDBox>
                      </Grid>
                      <Grid item xs={6} sm={3}>
                        <MDBox
                          sx={{
                            background: darkMode
                              ? "linear-gradient(195deg, rgba(255, 152, 0, 0.1), rgba(245, 124, 0, 0.1))"
                              : "linear-gradient(195deg, rgba(255, 152, 0, 0.05), rgba(245, 124, 0, 0.05))",
                            borderRadius: "12px",
                            padding: "20px",
                            textAlign: "center",
                            border: "1px solid",
                            borderColor: darkMode
                              ? "rgba(255, 152, 0, 0.2)"
                              : "rgba(255, 152, 0, 0.15)",
                          }}
                        >
                          <MDTypography
                            variant="h3"
                            fontWeight="bold"
                            color="warning"
                          >
                            {data.stats.dc}
                          </MDTypography>
                          <MDTypography
                            variant="button"
                            fontWeight="medium"
                            sx={{ opacity: 0.8, mt: 1 }}
                          >
                            DC Charge Points
                          </MDTypography>
                        </MDBox>
                      </Grid>
                      <Grid item xs={6} sm={3}>
                        <MDBox
                          sx={{
                            background: darkMode
                              ? "linear-gradient(195deg, rgba(156, 39, 176, 0.1), rgba(123, 31, 162, 0.1))"
                              : "linear-gradient(195deg, rgba(156, 39, 176, 0.05), rgba(123, 31, 162, 0.05))",
                            borderRadius: "12px",
                            padding: "20px",
                            textAlign: "center",
                            border: "1px solid",
                            borderColor: darkMode
                              ? "rgba(156, 39, 176, 0.2)"
                              : "rgba(156, 39, 176, 0.15)",
                          }}
                        >
                          <MDTypography
                            variant="h3"
                            fontWeight="bold"
                            color="secondary"
                          >
                            {data.stats.twoWheelerDC}
                          </MDTypography>
                          <MDTypography
                            variant="button"
                            fontWeight="medium"
                            sx={{ opacity: 0.8, mt: 1 }}
                          >
                            2W Charge Points
                          </MDTypography>
                        </MDBox>
                      </Grid>
                    </Grid>
                    <Divider sx={{ my: 3 }} />
                    {/* <MDTypography variant="h6" fontWeight="bold" mb={2}>
                      Additional Statistics
                    </MDTypography>
                    <Grid container spacing={3}>
                      <Grid item xs={6} lg={3}>
                        <InfoCard
                          value={formatEnergy(
                            content?.stats?.totalEnergyConsumed
                          )}
                          label="Energy dispersed (kwh)"
                        />
                      </Grid>
                      <Grid item xs={6} lg={3}>
                        <InfoCard
                          value={content?.stats?.totalSessions}
                          label="Visits / Transactions"
                        />
                      </Grid>
               
                      <Grid item xs={6} lg={3}>
                        <InfoCard
                          value={content?.stats?.kmPowered}
                          label="KMS powered (km)"
                        />
                      </Grid>
                      <Grid item xs={6} lg={3}>
                        <InfoCard
                          value={content?.stats?.co2Saved}
                          label="CO2 saved (kg)"
                        />
                      </Grid>
            
                    </Grid> */}
                  </MDBox>
                </Card>
              </Grid>

              {/* Location Details & Contact Information Side by Side */}
              <Grid item xs={12} md={6}>
                <Card
                  sx={{
                    boxShadow: darkMode
                      ? "0 4px 12px rgba(0,0,0,0.3)"
                      : "0 4px 12px rgba(0,0,0,0.1)",
                    borderRadius: "16px",
                    border: "1px solid",
                    borderColor: darkMode
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.08)",
                    height: "100%",
                  }}
                >
                  <MDBox p={3}>
                    <MDTypography variant="h5" fontWeight="bold" mb={3}>
                      Location Details
                    </MDTypography>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Typography variant="h6">Address</Typography>
                        <Typography mb={2}>{content?.address}</Typography>
                        <Typography variant="h6">Hours</Typography>

                        {content?.activeOperationalHoursSlots?.map((slot, index) => (
                          slot.enabled && (
                            <Typography key={slot._id || index} mb={1}>
                              {formatTime(slot.startTime)} - {formatTime(slot.endTime)}
                            </Typography>
                          )
                        ))}

                        <Grid container spacing={1}>
                          <Grid item xs={6}>
                            <Typography variant="h6">Charging</Typography>
                            <Typography mb={3}>
                              {content?.freepaid?.charging ? "FREE" : "PAID"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="h6">Parking</Typography>
                            <Typography mb={3}>
                              {content?.freepaid?.parking
                                ? "FREE"
                                : content?.parkingCost?.amount +
                                " " +
                                content?.parkingCost?.currency}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* Facilities */}
                      <Grid item xs={12} mb={2}>
                        <Typography variant="h6" mb={1.5}>
                          Facilities
                        </Typography>
                        <Grid container spacing={2}>
                          {Array.isArray(content?.facilities) &&
                            content?.facilities.map((facility, index) => (
                              <Tooltip
                                title={facility.name}
                                key={facility.name || index}
                              >
                                <Grid
                                  item
                                  xs={4}
                                  sm={2}
                                  md={4}
                                  lg={2}
                                  key={index}
                                >
                                  <Avatar
                                    sx={{
                                      bgcolor: green[500],
                                      width: 40,
                                      height: 40,
                                    }}
                                  >
                                    {iconMap[facility.name] || (
                                      <MoreHorizIcon />
                                    )}
                                  </Avatar>
                                </Grid>
                              </Tooltip>
                            ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </MDBox>
                </Card>
              </Grid>

              {/* Contact Information Card */}
              <Grid item xs={12} md={6}>
                <Card
                  sx={{
                    boxShadow: darkMode
                      ? "0 4px 12px rgba(0,0,0,0.3)"
                      : "0 4px 12px rgba(0,0,0,0.1)",
                    borderRadius: "16px",
                    border: "1px solid",
                    borderColor: darkMode
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.08)",
                    height: "100%",
                  }}
                >
                  <MDBox p={3}>
                    <MDTypography variant="h5" fontWeight="bold" mb={3}>
                      Contact Information
                    </MDTypography>
                    <Box display="flex" flexDirection="column" gap={1.5}>
                      <Box display="flex" justifyContent="space-between">
                        <MDTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ opacity: 0.8 }}
                        >
                          Site Engineer:
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="medium">
                          {content?.salesManager?.name}
                        </MDTypography>
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <MDTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ opacity: 0.8 }}
                        >
                          Site Engineer Phone:
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="medium">
                          {content?.salesManager?.phoneNumber}
                        </MDTypography>
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <MDTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ opacity: 0.8 }}
                        >
                          Site Engineer Email:
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="medium">
                          {content?.salesManager?.email}
                        </MDTypography>
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <MDTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ opacity: 0.8 }}
                        >
                          Security Guard:
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="medium">
                          {content?.dealer?.name}
                        </MDTypography>
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <MDTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ opacity: 0.8 }}
                        >
                          Security Guard Phone:
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="medium">
                          {content?.dealer?.phoneNumber}
                        </MDTypography>
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <MDTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ opacity: 0.8 }}
                        >
                          Security Guard Email:
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="medium">
                          {content?.dealer?.email}
                        </MDTypography>
                      </Box>
                    </Box>
                  </MDBox>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card
                  sx={{
                    boxShadow: darkMode
                      ? "0 4px 12px rgba(0,0,0,0.3)"
                      : "0 4px 12px rgba(0,0,0,0.1)",
                    borderRadius: "16px",
                    border: "1px solid",
                    borderColor: darkMode
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.08)",
                  }}
                >
                  <MDBox p={3}>
                    <MDTypography variant="h5" fontWeight="bold" mb={3}>
                      Location Images
                    </MDTypography>

                    <Image.PreviewGroup>
                      <Grid container direction="column" spacing={2}>
                        {/* Main image */}
                        <Grid item xs={12}>
                          {(() => {
                            const rawKey = content?.locationImage?.[0];
                            const mainUrl =
                              mainDisplayUrl ||
                              (process.env.REACT_APP_PUBLIC_URL && rawKey
                                ? process.env.REACT_APP_PUBLIC_URL + rawKey
                                : DUMMY_IMG);

                            const video = isVideoUrl(mainUrl);

                            if (video) {
                              return (
                                <video
                                  src={mainUrl}
                                  controls
                                  style={{
                                    width: "100%",
                                    height: 300,
                                    objectFit: "cover",
                                    borderRadius: 12,
                                  }}
                                />
                              );
                            }

                            return (
                              <Image
                                src={mainUrl}
                                alt="Location Image"
                                style={{
                                  width: "100%",
                                  height: 300,
                                  objectFit: "cover",
                                  borderRadius: 12,
                                }}
                                onError={(e) => {
                                  if (
                                    !e.currentTarget.src.includes(
                                      "/assets/images/dummy_Image.png"
                                    )
                                  ) {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = DUMMY_IMG;
                                  }
                                }}
                              />
                            );
                          })()}
                        </Grid>

                        {additionalImages.length > 0 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              flexDirection="row"
                              flexWrap="nowrap"
                              columnGap={1}
                            >
                              {additionalImages
                                .slice(0, 4)
                                .map((image, index) => {
                                  const thumbUrl =
                                    mainDisplayUrl ||
                                    (process.env.REACT_APP_PUBLIC_URL && image
                                      ? process.env.REACT_APP_PUBLIC_URL +
                                      image
                                      : DUMMY_IMG);

                                  const video = isVideoUrl(thumbUrl);

                                  return (
                                    <Box key={index}>
                                      {video ? (
                                        <video
                                          src={thumbUrl}
                                          controls
                                          muted
                                          playsInline
                                          style={{
                                            width: 80,
                                            height: 80,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                            display: "block",
                                          }}
                                        />
                                      ) : (
                                        <Image
                                          src={thumbUrl}
                                          alt={`Location Media ${index + 1}`}
                                          style={{
                                            width: 180,
                                            height: 180,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                            display: "block",
                                          }}
                                          onError={(e) => {
                                            if (
                                              !e.currentTarget.src.includes(
                                                "/assets/images/dummy_Image.png"
                                              )
                                            ) {
                                              e.currentTarget.onerror = null;
                                              e.currentTarget.src = DUMMY_IMG;
                                            }
                                          }}
                                        />
                                      )}
                                    </Box>
                                  );
                                })}
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </Image.PreviewGroup>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </MDBox>
      )}
      {/* modal for add charger */}
      <Dialog
        open={openDialog}
        // maxWidth="md"
        fullWidth
        onClose={handleCloseDialog}
      >
        <DialogTitle
          style={{ backgroundColor: darkMode ? "rgb(35 40 61)" : "#ffff" }}
          className="dialogtitle"
        >
          Add a Charger
        </DialogTitle>
        <DialogContent
          style={{ backgroundColor: darkMode ? "rgb(35 40 61)" : "#ffff" }}
        >
          <Form
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 18,
            }}
            form={form}
            name="dynamic_form_complex"
            style={{
              maxWidth: 700,
            }}
            autoComplete="off"
            initialValues={{
              chargerInfo: [{}],
            }}
            onValuesChange={(changedValues, allValues) => {
              setFormValues(allValues);
            }}
          >
            <Form.List name="chargerInfo">
              {(fields) => (
                <div
                  style={{
                    display: "flex",
                    rowGap: 16,
                    flexDirection: "column",
                  }}
                >
                  {fields.map((field) => (
                    <AntCard
                      size="default"
                      title={`Charger Details`}
                      style={{
                        width: "100%",
                        minHeight: 200,
                        padding: "16px",
                        maxWidth: "700px",
                      }}

                    >
                      <Form.Item
                        label="Charger ID"
                        name={[field.name, "name"]}
                        rules={[
                          { required: true, message: "Charger ID is required" },
                          { min: 3, max: 20, message: "Charger ID must be 3–20 characters" },
                          {
                            pattern: /^[A-Za-z0-9]+$/,
                            message: "Only letters and numbers allowed (no spaces)",
                          },
                        ]}
                      >
                        <Input
                          maxLength={20}
                          onChange={(e) => {
                            form.setFieldValue(
                              ["chargerInfo", field.name, "name"],
                              e.target.value.replace(/[^A-Za-z0-9]/g, "")
                            );
                          }}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Charger Name"
                        name={[field.name, "chargerName"]}
                        rules={[
                          { required: true, message: "Charger Name is required" },
                          { min: 3, max: 30, message: "Must be 3–30 characters" },
                          {
                            pattern: /^[A-Za-z0-9 ]+$/,
                            message: "Only letters, numbers and spaces allowed",
                          },
                        ]}
                      >
                        <Input
                          maxLength={30}
                          onChange={(e) => {
                            form.setFieldValue(
                              ["chargerInfo", field.name, "chargerName"],
                              e.target.value.replace(/[^A-Za-z0-9 ]/g, "")
                            );
                          }}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Power Output"
                        name={[field.name, "powerOutput"]}
                        rules={[
                          { required: true, message: "Power Output is required" },
                          {
                            type: "number",
                            min: 1,
                            max: 500,
                            message: "Power Output must be between 1 and 500 kW",
                          },
                        ]}
                      >
                        <InputNumber
                          min={1}
                          max={500}
                          precision={0}
                          addonAfter="kW"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Cost Per Unit"
                        name={[field.name, "amount"]}
                        rules={[
                          { required: true, message: "Cost is required" },
                          {
                            type: "number",
                            min: 0.1,
                            max: 1000,
                            message: "Cost must be between 0.1 and 1000",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0.1}
                          max={1000}
                          precision={2}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Charger Type"
                        name={[field.name, "type"]}
                        labelCol={{ xs: 24, sm: 12, md: 8 }}
                        rules={[
                          {
                            required: true,
                            message: "Select something!",
                          },
                        ]}
                      >
                        <Radio.Group
                          onChange={(e) => handleTypeChange(field.name, e)}
                        >
                          <Radio value="AC"> AC </Radio>
                          <Radio value="DC"> DC </Radio>
                        </Radio.Group>
                      </Form.Item>
                      {form.getFieldValue([
                        "chargerInfo",
                        field.name,
                        "type",
                      ]) && (
                          <Form.Item
                            label="Connector Type"
                            name={[field.name, "subtype"]}
                            labelCol={{ xs: 24, sm: 12, md: 8 }}
                            rules={[
                              {
                                required: true,
                                message: "Select something!",
                              },
                            ]}
                            initialValue="CCS2"
                          >
                            <Radio.Group>
                              <Radio value="CCS2"> CCS2 </Radio>
                              <Radio
                                value="Type6"
                                disabled={
                                  form.getFieldValue([
                                    "chargerInfo",
                                    field.name,
                                    "type",
                                  ]) === "AC"
                                }
                              >
                                {" "}
                                Type6{" "}
                              </Radio>
                              <Radio
                                value="Type2"
                                disabled={
                                  form.getFieldValue([
                                    "chargerInfo",
                                    field.name,
                                    "type",
                                  ]) === "DC"
                                }
                              >
                                {" "}
                                Type2{" "}
                              </Radio>
                              <Radio
                                value="Type7"
                                disabled={
                                  form.getFieldValue([
                                    "chargerInfo",
                                    field.name,
                                    "type",
                                  ]) === "AC"
                                }
                              >
                                {" "}
                                Type7{" "}
                              </Radio>
                            </Radio.Group>
                          </Form.Item>
                        )}
                      <Form.Item
                        label="No of Connectors"
                        name={[field.name, "NoOfconnector"]}
                        labelCol={{ xs: 24, sm: 12, md: 8 }}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter a value",
                          },
                          {
                            type: "number",
                            min: 1,
                            max: 8,
                            message: "Value must be between 1 and 8",
                          },
                        ]}
                      >
                        <InputNumber
                          variant="filled"
                          style={{ width: "100%" }}
                          onChange={handleConnectorChange1}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Onboarding Date"
                        name={[field.name, "onboardingDate"]}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 12 }}
                        rules={[
                          { required: true, message: "Onboarding Date is required" },
                        ]}
                      >
                        <DatePicker
                          format="YYYY-MM-DD"
                          style={{ width: "100%" }}
                          disabledDate={(current) => current && current > new Date()}
                        />
                      </Form.Item>

                    </AntCard>
                  ))}
                </div>
              )}
            </Form.List>

            <Form.Item noStyle shouldUpdate>
              {() => <Typography></Typography>}
            </Form.Item>
          </Form>
          <div style={{ marginTop: "16px", textAlign: "end" }}>
            <Button
              variant="outlined"
              danger
              color="error"
              onClick={handleCloseDialog}
              style={{
                marginRight: "1rem",
                backgroundColor: `${colorMap["primary"]}`,
                color: "#FFF",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={handleAddCharger}
              style={{
                backgroundColor: `${colorMap["primary"]}`,
                color: "#FFF",
              }}
            >
              Add
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={openDialog1} fullWidth onClose={handleCloseDialog1}>
        <DialogTitle
          style={{ backgroundColor: darkMode ? "rgb(35 40 61)" : "#ffff" }}
          className="dialogtitle"
        >
          Update the Charger
        </DialogTitle>
        <DialogContent
          style={{ backgroundColor: darkMode ? "rgb(35 40 61)" : "#ffff" }}
        >
          <Form
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 18,
            }}
            form={form}
            name="dynamic_form_complex"
            style={{
              maxWidth: 700,
            }}
            autoComplete="off"
            initialValues={{
              chargerInfo1: editChargerInfo || [{}],
            }}
            onValuesChange={(changedValues, allValues) => {
              setFormValues(allValues);
            }}
          >
            <Form.List name="chargerInfo1">
              {(fields) => (
                <div
                  style={{
                    display: "flex",
                    rowGap: 16,
                    flexDirection: "column",
                  }}
                >
                  {fields.map((field) => (
                    <AntCard
                      size="default"
                      title={`Charger Details`}
                      style={{
                        width: "100%",
                        minHeight: 200,
                        padding: "16px",
                        maxWidth: "700px",
                      }}
                    >
                      <Form.Item
                        label="Charger ID"
                        name={[field.name, "name"]}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter a value",
                          },
                          {
                            pattern: /^[a-zA-Z0-9]+$/,
                            message: "Only letters and numbers are allowed (no spaces or special characters)",
                          },
                        ]}
                      >
                        <Input
                          variant="filled"
                          disabled
                          style={{
                            color: darkMode ? "white" : "black",
                            border: "1px solid black",
                            backgroundColor: darkMode ? "#1a2035" : "white",
                          }}
                          onChange={(e) => {
                            e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                          }}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Charger Name"
                        name={[field.name, "chargerName"]}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter a value",
                          },
                          {
                            pattern: /^[a-zA-Z0-9 ]+$/,
                            message: "Only letters, numbers, and spaces are allowed",
                          },
                        ]}
                      >
                        <Input
                          variant="filled"
                          style={{
                            color: darkMode ? "white" : "black",
                            border: "1px solid black",
                            backgroundColor: darkMode ? "#1a2035" : "white",
                          }}
                          onChange={(e) => {
                            e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                          }}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Power Output"
                        name={[field.name, "powerOutput"]}
                        labelCol={{ xs: 24, sm: 12, md: 8 }}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter a value",
                          },
                        ]}
                      >
                        <InputNumber
                          addonAfter="kW"
                          variant="filled"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Cost Per Unit"
                        name={[field.name, "amount"]}
                        labelCol={{ xs: 24, sm: 12, md: 8 }}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter a value",
                          },
                        ]}
                      >
                        <InputNumber
                          addonBefore={selectAfter}
                          style={{ width: "100%" }}
                          variant="filled"
                        />
                      </Form.Item>
                      <Form.Item
                        label="Charger Type"
                        name={[field.name, "type"]}
                        labelCol={{ xs: 24, sm: 12, md: 8 }}
                        rules={[
                          {
                            required: true,
                            message: "Select something!",
                          },
                        ]}
                      >
                        <Radio.Group
                          onChange={(e) => handleTypeChange1(field.name, e)}
                        >
                          <Radio value="AC"> AC </Radio>
                          <Radio value="DC"> DC </Radio>
                        </Radio.Group>
                      </Form.Item>
                      {form.getFieldValue([
                        "chargerInfo1",
                        field.name,
                        "type",
                      ]) && (
                          <Form.Item
                            label="Connector Type"
                            name={[field.name, "subtype"]}
                            labelCol={{ xs: 24, sm: 12, md: 8 }}
                            rules={[
                              {
                                required: true,
                                message: "Select something!",
                              },
                            ]}
                            initialValue="CCS2"
                          >
                            <Radio.Group>
                              <Radio value="CCS2"> CCS2 </Radio>
                              <Radio
                                value="Type6"
                                disabled={
                                  form.getFieldValue([
                                    "chargerInfo1",
                                    field.name,
                                    "type",
                                  ]) === "AC"
                                }
                              >
                                {" "}
                                Type6{" "}
                              </Radio>
                              <Radio
                                value="Type2"
                                disabled={
                                  form.getFieldValue([
                                    "chargerInfo1",
                                    field.name,
                                    "type",
                                  ]) === "DC"
                                }
                              >
                                {" "}
                                Type2{" "}
                              </Radio>
                              <Radio
                                value="Type7"
                                disabled={
                                  form.getFieldValue([
                                    "chargerInfo1",
                                    field.name,
                                    "type",
                                  ]) === "AC"
                                }
                              >
                                {" "}
                                Type7{" "}
                              </Radio>
                            </Radio.Group>
                          </Form.Item>
                        )}
                      <Form.Item
                        label="No of Connectors"
                        name={[field.name, "NoOfconnector"]}
                        labelCol={{ xs: 24, sm: 12, md: 8 }}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter a value",
                          },
                          {
                            type: "number",
                            min: 1,
                            max: 8,
                            message: "Value must be between 1 and 8",
                          },
                        ]}
                      >
                        <InputNumber
                          variant="filled"
                          style={{ width: "100%" }}
                          onChange={handleConnectorChange2}
                        />
                      </Form.Item>
                    </AntCard>
                  ))}
                </div>
              )}
            </Form.List>

            <Form.Item noStyle shouldUpdate>
              {() => <Typography></Typography>}
            </Form.Item>
          </Form>
          <div style={{ marginTop: "16px", textAlign: "end" }}>
            <Button
              variant="outlined"
              danger
              color="error"
              onClick={handleCloseDialog1}
              style={{
                marginRight: "1rem",
                backgroundColor: `${colorMap["primary"]}`,
                color: "white",
              }}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: `${colorMap["primary"]}`,
                color: "white",
              }}
              variant="outlined"
              color="error"
              onClick={handleUpdateCharger}
            >
              Update
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <style>
        <style>
          {`
  .dark-mode-form-item {
    color: white !important;
  }
  `}
        </style>
      </style>
      <Card>
        <MDBox
          mx={2}
          mt={3}
          py={1}
          px={2}
          variant="gradient"
          bgColor={sidenavColor}
          borderRadius="lg"
          coloredShadow={sidenavColor}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <MDTypography variant="h6" color="white">
              All Chargers of {content.locationName}
            </MDTypography>
            <Button
              icon={<AddIcon />}
              style={{
                backgroundColor: `${colorMap["primary"]}`,
                color: "white",
                border: "1px solid white",
              }}
              iconPosition="start"
              variant="outlined"
              size="small"
              onClick={() => setOpenDialog(true)}
            >
              Add Charger
            </Button>
          </Grid>
        </MDBox>
        {isLocationTableLoading ? (
          <Loader />
        ) : (
          <CustomMaterialTable
            columns={columns}
            data={rows}
            darkMode={darkMode}
            initialState={{
              columnVisibility: {
                status: true,
                name: true,
                locationName: true,
                chargerName: true,
                address: false,
                chargePointSerialNumber: false,
                chargePointVendor: false,
                model: false,
                city: false,
                chargePointModel: false,
                powerOutput: false,
                type: false,
                subtype: false,
                state: false,
                firmwareVersion: false,
                imsi: false,
                iccid: false,
                costAmount: false,
                costCurrency: false,
                energyConsumptions: false,
                NoOfconnector: false,
                lastPing: false,
                qrcodeurl: true,
                action: true,
              },
            }}
          />
        )}
      </Card>
      <Card style={{ marginTop: "4rem" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={1}
          px={2}
          variant="gradient"
          bgColor={sidenavColor}
          borderRadius="lg"
          coloredShadow={sidenavColor}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <MDTypography variant="h6" color="white">
              All Reviews of {content.locationName}
            </MDTypography>
          </Grid>
        </MDBox>
        {isReviewTableLoading ? (
          <Loader />
        ) : (
          <CustomMaterialTable
            columns={columns1}
            data={rows1}
            darkMode={darkMode}
          />
        )}
      </Card>

      <Modal
        open={qrModalOpen}
        title={qrModalTitle || "QR Code"}
        footer={null}
        centered
        width={320}
        style={{
          padding: 16,
          textAlign: "center",
        }}
        onCancel={() => {
          setQrModalOpen(false);
          setQrModalUrl(null);
          setQrModalKey(null);
        }}
      >
        {qrModalLoading && (
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            <Loader />
          </div>
        )}

        {!qrModalLoading && qrModalUrl && (
          <div style={{ textAlign: "center" }}>
            <Image
              src={qrModalUrl}
              alt="QR Code"
              style={{ maxWidth: 160, maxHeight: 160 }}
            />
            <div style={{ marginTop: 16 }}>
              <Button onClick={handleDownloadQr}>Download</Button>
            </div>
          </div>
        )}

        {!qrModalLoading && !qrModalUrl && (
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            QR code not available
          </div>
        )}
      </Modal>
    </DashboardLayout>
  );
};

export default ViewLocation;
